import { ChipProps, Stack } from "@mui/material";
import AccessCustomChip from "./access-custom-chip";

interface AccessCustomChipsSummaryProps {
  labels: string[];
  nbToShow?: number;
  chipsColor?: ChipProps["color"];
  chipsIcon?: ChipProps["icon"];
}

const AccessCustomChipsSummary = (props: AccessCustomChipsSummaryProps) => {
  const { labels, nbToShow = labels.length, chipsColor, chipsIcon } = props;

  return (
    <Stack direction="row" alignItems="center" sx={{ flexWrap: "wrap", gap: 0.5 }}>
      {labels.slice(0, nbToShow).map((label, index) => (
        <AccessCustomChip key={index} label={label} color={chipsColor} icon={chipsIcon} />
      ))}
      {labels.length > nbToShow && <AccessCustomChip label={`+${labels.length - nbToShow}`} color={chipsColor} />}
    </Stack>
  );
};

export default AccessCustomChipsSummary;
